module.exports = __webpack_public_path__ + "static/img/logo.c7e4c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 42